import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import Loading from 'components/Loading';
import { SITE } from './config/config';
import favicon_ok9 from './assets/images/favicon-ok9.ico';
import HomePage from 'pages/Home';
import OK9Page from 'pages/OK9';
import RulePage from 'pages/OK9/rule';
import PrizeStructure from 'pages/OK9/prizeStructure';
import Page404 from 'pages/Error';

const favicons = {
  ok9: favicon_ok9,
};

function Apps() {
  useEffect(() => {
    const faviconElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="/" element={<OK9Page />} />
            <Route path="/prediction" element={<OK9Page />} />
            <Route path="/rule" element={<RulePage />} />
            <Route path="/prize-structure" element={<PrizeStructure />} />
            {/* Add other routes here */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
